import { defineNuxtRouteMiddleware, useApi, useCoreLogger, usePartner, useState } from '#imports'

export default defineNuxtRouteMiddleware(async (to) => {
    if (import.meta.client) return

    const logger = useCoreLogger()

    const hasTracked = useState('middleware:tracking:has-tracked', () => false)

    if (hasTracked.value) return

    const { isFromPartner, hasPartnerQueryParams } = usePartner()

    const preparedQuery = hasPartnerQueryParams(to.query) ? to.query : to.meta.tracking?.partner?.defaults

    // Early exit if criteria is not met
    if (!preparedQuery) return

    isFromPartner.value = true

    /* const preparedTo: SetRequired<RouteLocationPathRaw, 'query'> = {
        path: to.path,
        query: { ...to.query },
        hash: to.hash,
    } */

    const api = useApi({
        service: 'monolith'
    })
    try {
        await api('/referer_data', {
            query: preparedQuery,
        })

        hasTracked.value = true
    }
    catch (err) {
        logger.withTag('middleware/tracking.global.ts').error(err)
    }

    /* let hasChanged = false
    for (const queryParam of partnerQueryParams) {
        if (!(queryParam in preparedTo.query)) continue

        delete preparedTo.query[queryParam]
        hasChanged = true
    }

    if (!hasChanged) {
        return
    }

    return navigateTo(preparedTo, {
        redirectCode: 302,
    }) */

    return
})
